import { render, staticRenderFns } from "./GlobalSpecialClosures.vue?vue&type=template&id=dfcfe998"
import script from "./GlobalSpecialClosures.vue?vue&type=script&lang=js"
export * from "./GlobalSpecialClosures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports